/* Cart Commander slide cart (Phase 2).
 * Replaces the Dynamatic cart drawer: reward bar with store-credit tiers,
 * free gift auto-add, line items with qty steppers, in-cart upsells.
 * Config comes from the Cart Commander app (/storefront/cart-config); if the
 * slide cart is disabled there, this script does nothing at all.
 */
(function () {
  "use strict";
  var CC_HOST = "https://glorious-crow-287.convex.site"; // replaced at install
  var cfg = null;
  var cart = null;
  var giftBusy = false;

  var STYLE_VARS = {
    headerBg: "--ccc-header-bg",
    headerText: "--ccc-header-text",
    fontFamily: "--ccc-font",
    accentColor: "--ccc-accent",
    progressFill: "--ccc-progress-fill",
    progressTrack: "--ccc-progress-track",
    dotColor: "--ccc-dot-color",
    disclaimerBg: "--ccc-disclaimer-bg",
    disclaimerText: "--ccc-disclaimer-text",
    itemTitleColor: "--ccc-item-title",
    checkoutBg: "--ccc-checkout-bg",
    checkoutText: "--ccc-checkout-text",
    giftBadgeBg: "--ccc-gift-bg",
    giftBadgeText: "--ccc-gift-text",
    borderRadius: "--ccc-radius",
    drawerWidth: "--ccc-width",
    upsellImageWidth: "--ccc-up-img-w",
    upsellImageHeight: "--ccc-up-img-h",
    upsellImageFit: "--ccc-up-img-fit",
    upsellImageAspect: "--ccc-up-img-aspect",
    bodyBg: "--ccc-body-bg",
    bodyText: "--ccc-body-text",
    rewardMsgColor: "--ccc-reward-msg",
    rewardMsgFontSize: "--ccc-reward-msg-size",
    tierLabelColor: "--ccc-tier-label",
    tierLabelFontSize: "--ccc-tier-label-size",
    disclaimerFontSize: "--ccc-disclaimer-size",
    titleFontSize: "--ccc-title-size",
    itemTitleFontSize: "--ccc-item-title-size",
    priceFontSize: "--ccc-price-size",
    iconColor: "--ccc-icon",
    savingsColor: "--ccc-savings",
    subtotalColor: "--ccc-subtotal",
    checkoutFontSize: "--ccc-checkout-size",
    upsellHeadingColor: "--ccc-upsell-heading",
    panelWidth: "--ccc-panel-width",
    panelHeaderBg: "--ccc-panel-header-bg",
    panelHeaderText: "--ccc-panel-header-text",
    panelBg: "--ccc-panel-bg",
    upsellTitleColor: "--ccc-upsell-title",
    upsellTitleSize: "--ccc-upsell-title-size",
    upsellPriceColor: "--ccc-upsell-price",
    upsellAddBg: "--ccc-upsell-add-bg",
    upsellAddText: "--ccc-upsell-add-text",
  };

  // Inline SVG icons (stroke = currentColor) so they stand out on any
  // background color the merchant picks — no emoji, no font dependency.
  var SVG_ATTRS =
    ' viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"' +
    ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';
  var SVG_CART =
    '<svg class="ccc-ico ccc-ico-cart"' + SVG_ATTRS + '><circle cx="9" cy="21" r="1.5"/><circle cx="19" cy="21" r="1.5"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57L22.5 7H5.12"/></svg>';
  var SVG_TRASH =
    '<svg class="ccc-ico ccc-ico-trash"' + SVG_ATTRS + '><path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>';
  var SVG_TAG =
    '<svg class="ccc-ico ccc-ico-tag"' + SVG_ATTRS + '><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"/><circle cx="7.5" cy="7.5" r="1.5" fill="currentColor" stroke="none"/></svg>';
  var SVG_CLOSE =
    '<svg class="ccc-ico ccc-ico-close"' + SVG_ATTRS + '><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  var SVG_CHECK =
    '<svg class="ccc-ico ccc-ico-check"' + SVG_ATTRS + ' stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>';

  function money(cents, dir) {
    // Whole-dollar display rule (Darren, 2026-08-02): prices round UP, and
    // discount-derived amounts (discounted price, subtotal) round DOWN so the
    // rounding always lands in the customer's favor. No trailing cents, ever.
    var d = cents / 100;
    d = dir === "down" ? Math.floor(d) : Math.ceil(d);
    return "$" + d.toLocaleString("en-US");
  }
  function moneyShort(cents) {
    // Whole dollars, rounded UP so the stated amount always earns the reward.
    // Keeps the reward-bar message as short as possible (Darren, 2026-08-02).
    return "$" + Math.ceil(cents / 100);
  }
  function esc(s) {
    var d = document.createElement("div");
    d.textContent = s == null ? "" : String(s);
    return d.innerHTML;
  }
  function isGift(item) {
    return !!(item.properties && item.properties._cc_gift);
  }

  // ---- drawer shell -------------------------------------------------------
  var overlay;
  var drawer;
  var sidePanel;
  var MOBILE_MQ = "(max-width: 900px)";
  function isMobile() {
    return window.matchMedia && window.matchMedia(MOBILE_MQ).matches;
  }
  // Per-device upsell placement: "inline" | "side-panel" (desktop) | "hidden".
  function upsellPlacement() {
    if (!cfg || !cfg.upsell) return "hidden";
    if (isMobile()) return cfg.upsell.placementMobile || "inline";
    return cfg.upsell.placementDesktop || cfg.upsell.placement || "inline";
  }
  // Bare numbers in size-like style values are treated as px.
  var PX_KEYS = {
    borderRadius: 1, drawerWidth: 1, panelWidth: 1, upsellImageWidth: 1,
    upsellImageHeight: 1, rewardMsgFontSize: 1, tierLabelFontSize: 1,
    disclaimerFontSize: 1, titleFontSize: 1, itemTitleFontSize: 1,
    priceFontSize: 1, checkoutFontSize: 1, upsellTitleSize: 1,
  };
  function normalizeStyle(style) {
    if (!style) return style;
    Object.keys(PX_KEYS).forEach(function (k) {
      if (style[k] != null && /^\d+(\.\d+)?$/.test(String(style[k]).trim()))
        style[k] = String(style[k]).trim() + "px";
    });
    return style;
  }
  function buildShell() {
    if (cfg.style) normalizeStyle(cfg.style);
    overlay = document.createElement("div");
    overlay.id = "cc-cart-overlay";
    // Inline style so theme :empty/display resets can never hide the overlay.
    overlay.style.display = "block";
    overlay.setAttribute("aria-hidden", "true");
    overlay.addEventListener("click", close);
    // <div>, not <aside>: role="dialog" is not allowed on <aside> (axe aria-allowed-role).
    drawer = document.createElement("div");
    drawer.id = "cc-cart-drawer";
    drawer.setAttribute("role", "dialog");
    drawer.setAttribute("aria-modal", "true");
    drawer.setAttribute("aria-label", cfg.title);
    drawer.setAttribute("tabindex", "-1");
    // Closed drawer is off-screen but would still be tab-reachable — keep it
    // inert + hidden from the accessibility tree until opened.
    drawer.setAttribute("aria-hidden", "true");
    if ("inert" in drawer) drawer.inert = true;
    Object.keys(STYLE_VARS).forEach(function (k) {
      if (cfg.style && cfg.style[k])
        drawer.style.setProperty(STYLE_VARS[k], cfg.style[k]);
    });
    if (cfg.style && cfg.style.upsellImageAspect && !cfg.style.upsellImageHeight)
      drawer.style.setProperty("--ccc-up-img-h", "auto");
    drawer.innerHTML =
      '<div class="ccc-header"><h2>' +
      esc(cfg.title) +
      '</h2><button class="ccc-close" type="button" aria-label="Close cart">' + SVG_CLOSE + '</button></div>' +
      '<div class="ccc-body"></div><div class="ccc-footer"></div>' +
      '<div class="ccc-live ccc-sr" role="status" aria-live="polite"></div>' +
      '<div class="ccc-spin" aria-hidden="true"><div class="ccc-spin-ring"></div></div>';
    drawer
      .querySelector(".ccc-close")
      .addEventListener("click", close);
    document.body.appendChild(overlay);
    document.body.appendChild(drawer);
    if (cfg.upsell && upsellPlacement() === "side-panel") {
      sidePanel = document.createElement("aside");
      sidePanel.id = "cc-cart-sidepanel";
      Object.keys(STYLE_VARS).forEach(function (k) {
        if (cfg.style && cfg.style[k])
          sidePanel.style.setProperty(STYLE_VARS[k], cfg.style[k]);
      });
      sidePanel.setAttribute("aria-label", cfg.upsell.heading || "Recommended products");
      sidePanel.setAttribute("aria-hidden", "true");
      if ("inert" in sidePanel) sidePanel.inert = true;
      sidePanel.innerHTML =
        '<div class="ccc-panel-header" role="heading" aria-level="2">' +
        esc(cfg.upsell.heading) +
        '</div><div class="ccc-panel-body"><div class="ccc-upsell"></div></div>';
      document.body.appendChild(sidePanel);
    }
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.classList.contains("cc-open")) {
        close();
        return;
      }
      // Focus trap: Tab cycles within the open drawer (+ visible side panel).
      if (e.key !== "Tab" || !drawer.classList.contains("cc-open")) return;
      var sel = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';
      var els = Array.prototype.slice.call(drawer.querySelectorAll(sel));
      if (sidePanel && sidePanel.classList.contains("cc-open"))
        els = els.concat(Array.prototype.slice.call(sidePanel.querySelectorAll(sel)));
      els = els.filter(function (n) { return n.offsetParent !== null; });
      if (els.length === 0) return;
      var first = els[0];
      var last = els[els.length - 1];
      var inside = drawer.contains(document.activeElement) ||
        (sidePanel && sidePanel.contains(document.activeElement));
      if (e.shiftKey && (document.activeElement === first || !inside)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (document.activeElement === last || !inside)) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  function announce(text) {
    var live = drawer && drawer.querySelector(".ccc-live");
    if (!live) return;
    live.textContent = "";
    setTimeout(function () {
      live.textContent = text;
    }, 50);
  }

  function beacon(widget, type, valueCents) {
    try {
      var payload = { widget: widget, type: type };
      if (valueCents != null) payload.valueCents = valueCents;
      navigator.sendBeacon(
        CC_HOST + "/storefront/event",
        new Blob([JSON.stringify(payload)], { type: "application/json" })
      );
    } catch (e) {}
  }

  // Revenue attribution: remember which widget added a variant via a hidden
  // cart attribute (_cc_<variantId>); the orders/create webhook credits the
  // widget with that line's revenue when the order completes.
  function tagAttribution(variantId, widgetKey) {
    var attrs = {};
    attrs["_cc_" + variantId] = widgetKey;
    return fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: attrs }),
    }).catch(function () {});
  }

  // Referral capture: ?ref=CODE on any landing page → remembered 90 days →
  // tagged onto the cart as the `_cc_ref` attribute so orders/paid webhooks
  // can attribute the conversion. Idempotent; last-click wins.
  (function captureReferral() {
    try {
      var params = new URLSearchParams(window.location.search);
      var incoming = params.get("ref");
      if (incoming && /^[A-Za-z0-9]{4,16}$/.test(incoming)) {
        localStorage.setItem(
          "cc_ref",
          JSON.stringify({ code: incoming.toUpperCase(), ts: Date.now() })
        );
      }
      var stored = JSON.parse(localStorage.getItem("cc_ref") || "null");
      if (!stored || Date.now() - stored.ts > 90 * 86400000) return;
      if (localStorage.getItem("cc_ref_tagged") === stored.code) return;
      fetch("/cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { _cc_ref: stored.code } }),
      })
        .then(function () {
          localStorage.setItem("cc_ref_tagged", stored.code);
        })
        .catch(function () {});
    } catch (e) {}
  })();

  var lastFocused = null;
  function open() {
    refresh().then(function () {
      lastFocused = document.activeElement;
      overlay.classList.add("cc-open");
      drawer.classList.add("cc-open");
      drawer.removeAttribute("aria-hidden");
      if ("inert" in drawer) drawer.inert = false;
      if (sidePanel && sidePanel.querySelector(".ccc-upsell-tile")) {
        sidePanel.classList.add("cc-open");
        sidePanel.removeAttribute("aria-hidden");
        if ("inert" in sidePanel) sidePanel.inert = false;
      }
      document.documentElement.style.overflow = "hidden";
      // Move keyboard/screen-reader focus into the dialog (WCAG 2.4.3).
      var closeBtn = drawer.querySelector(".ccc-close");
      if (closeBtn) closeBtn.focus();
    });
  }
  function close() {
    overlay.classList.remove("cc-open");
    drawer.classList.remove("cc-open");
    drawer.setAttribute("aria-hidden", "true");
    if ("inert" in drawer) drawer.inert = true;
    if (sidePanel) {
      sidePanel.classList.remove("cc-open");
      sidePanel.setAttribute("aria-hidden", "true");
      if ("inert" in sidePanel) sidePanel.inert = true;
    }
    document.documentElement.style.overflow = "";
    // Return focus to whatever triggered the drawer (WCAG 2.4.3).
    if (lastFocused && typeof lastFocused.focus === "function")
      lastFocused.focus();
    lastFocused = null;
  }

  // ---- cart data ----------------------------------------------------------
  function fetchCart() {
    return fetch("/cart.js", { credentials: "same-origin" }).then(function (r) {
      return r.json();
    });
  }

  function refresh() {
    return fetchCart().then(function (c) {
      cart = c;
      return maybeToggleGift().then(render);
    });
  }

  // Optimistic cart updates: the drawer re-renders instantly from a local
  // model, rapid +/- clicks collapse into one debounced /cart/change.js call
  // per line (keyed by the line-item key so indices never shift), and the
  // server response reconciles totals/discounts afterwards.
  var sendQueue = Promise.resolve();
  var pendingQty = {};
  var sendTimer = null;

  function localRecalc() {
    var count = 0;
    var sub = 0;
    cart.items.forEach(function (item) {
      if (item.final_price != null)
        item.final_line_price = item.final_price * item.quantity;
      if (item.original_price != null)
        item.original_line_price = item.original_price * item.quantity;
      count += item.quantity;
      sub += item.final_line_price;
    });
    cart.item_count = count;
    cart.items_subtotal_price = sub;
  }

  function setQty(key, quantity) {
    cart.items = cart.items.filter(function (item) {
      if (item.key !== key) return true;
      if (quantity <= 0) return false;
      item.quantity = quantity;
      return true;
    });
    localRecalc();
    render();
    pendingQty[key] = quantity;
    if (sendTimer) clearTimeout(sendTimer);
    sendTimer = setTimeout(flushQty, 300);
  }

  function flushQty() {
    sendTimer = null;
    var batch = pendingQty;
    pendingQty = {};
    Object.keys(batch).forEach(function (key) {
      sendQueue = sendQueue.then(function () {
        return fetch("/cart/change.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: key, quantity: batch[key] }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (c) {
            if (c && c.items) cart = c;
          })
          .catch(function () {});
      });
    });
    sendQueue = sendQueue.then(function () {
      return maybeToggleGift().then(function () {
        // Only reconcile-render when no newer optimistic edits are pending.
        if (!sendTimer && Object.keys(pendingQty).length === 0) render();
      });
    });
  }

  // ---- free gift ----------------------------------------------------------
  function subtotalExGift() {
    var t = 0;
    cart.items.forEach(function (item) {
      if (!isGift(item)) t += item.final_line_price;
    });
    return t;
  }

  function maybeToggleGift() {
    if (!cfg.freeGift || giftBusy || !cart) return Promise.resolve();
    var threshold = cfg.freeGift.threshold * 100;
    var giftLine = null;
    cart.items.forEach(function (item, i) {
      if (isGift(item)) giftLine = i + 1;
    });
    var qualifies = subtotalExGift() >= threshold && cart.item_count > 0;
    if (qualifies && giftLine == null) {
      giftBusy = true;
      return fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: Number(cfg.freeGift.variantId),
          quantity: 1,
          properties: { _cc_gift: "1" },
        }),
      })
        .then(fetchCart)
        .then(function (c) {
          cart = c;
        })
        .catch(function () {})
        .finally(function () {
          giftBusy = false;
        });
    }
    if (!qualifies && giftLine != null) {
      giftBusy = true;
      return fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: giftLine, quantity: 0 }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (c) {
          cart = c;
        })
        .catch(function () {})
        .finally(function () {
          giftBusy = false;
        });
    }
    return Promise.resolve();
  }

  // ---- rendering ----------------------------------------------------------
  function rewardBarHtml() {
    var rb = cfg.rewardBar;
    if (!rb || !rb.tiers || rb.tiers.length === 0) return "";
    var subtotal = cart.items_subtotal_price; // cents, after line discounts
    var maxT = rb.tiers[rb.tiers.length - 1].threshold * 100;
    var next = null;
    for (var i = 0; i < rb.tiers.length; i++) {
      if (subtotal < rb.tiers[i].threshold * 100) {
        next = rb.tiers[i];
        break;
      }
    }
    var msg;
    var msgCls = "";
    if (next) {
      var need = moneyShort(next.threshold * 100 - subtotal);
      msg = rb.messageTemplate
        .replace("{amount}", "<strong>" + need + "</strong>")
        .replace("{reward}", "<strong>" + esc(next.label) + "</strong>");
    } else {
      // Complete message may wrap to two lines; the progress message never does.
      msg = esc(rb.completeMessage);
      msgCls = " cc-wrap";
    }
    var dots = "";
    var labels = "";
    // Circles are spaced EVENLY along the track (not proportionally to their
    // dollar value) so labels like $150/$200 never crowd each other.
    var n = rb.tiers.length;
    var positions = rb.tiers.map(function (_tier, i) {
      return ((i + 1) / n) * 94; // even gaps, last circle at 94%
    });
    // Progress fill interpolates between tier positions so a checkpoint's
    // circle lights up exactly when its dollar threshold is reached.
    function fillPct(sub) {
      if (sub <= 0) return 0;
      var prevT = 0;
      var prevP = 0;
      for (var fi = 0; fi < n; fi++) {
        var t = rb.tiers[fi].threshold * 100;
        var p = positions[fi];
        if (sub < t) return prevP + ((sub - prevT) / (t - prevT)) * (p - prevP);
        prevT = t;
        prevP = p;
      }
      return 100;
    }
    var pct = Math.min(100, fillPct(subtotal));
    var rows = [];
    positions.forEach(function (left, i) {
      if (i === 0) {
        rows.push(0);
        return;
      }
      rows.push(left - positions[i - 1] < 22 && rows[i - 1] === 0 ? 1 : 0);
    });
    var hasRow2 = rows.indexOf(1) !== -1;
    rb.tiers.forEach(function (tier, i) {
      var left = positions[i];
      var done = subtotal >= tier.threshold * 100;
      dots +=
        '<div class="ccc-dot' +
        (done ? " cc-done" : "") +
        '" style="left:' + left + '%">' + SVG_CHECK + "</div>";
      labels +=
        '<span class="ccc-dot-label' +
        (rows[i] === 1 ? " cc-row2" : "") +
        '" style="left:' + left + '%">$' +
        (tier.threshold % 1 === 0 ? tier.threshold : tier.threshold.toFixed(2)) +
        (i === n - 1 ? "+" : "") +
        "<b>" + esc(tier.label) + "</b></span>";
    });
    return (
      '<div class="ccc-reward"><p class="ccc-reward-msg' + msgCls + '" aria-live="polite">' +
      msg +
      '</p><div class="ccc-track" role="progressbar" aria-label="Reward progress"' +
      ' aria-valuemin="0" aria-valuemax="' + (maxT / 100) +
      '" aria-valuenow="' + Math.min(subtotal, maxT) / 100 +
      '" aria-valuetext="' + esc(money(Math.min(subtotal, maxT)) + " of " + money(maxT) + " toward rewards") +
      '"><div class="ccc-track-fill" style="width:' +
      pct +
      '%"></div><div class="ccc-dots" aria-hidden="true">' +
      dots +
      '</div></div><div class="ccc-dot-labels' + (hasRow2 ? " cc-two-rows" : "") + '" aria-hidden="true">' +
      labels +
      "</div></div>" +
      (rb.disclaimer
        ? '<div class="ccc-disclaimer">' + esc(rb.disclaimer) + "</div>"
        : "")
    );
  }

  function itemHtml(item, line) {
    var discounts = (item.line_level_discount_allocations || [])
      .map(function (d) {
        return (
          esc(d.discount_application.title) +
          " (Save " +
          money(d.amount) +
          ")"
        );
      })
      .join(", ");
    var gift = isGift(item);
    var hasDiscount = item.final_line_price < item.original_line_price;
    var price = gift
      ? '<span class="ccc-now">FREE</span>'
      : (hasDiscount
          ? '<span class="ccc-was"><span class="ccc-sr">Original price </span>' + money(item.original_line_price) + "</span>"
          : "") +
        '<span class="ccc-now">' + (hasDiscount ? '<span class="ccc-sr">Discounted price </span>' : "") + money(item.final_line_price, "down") + "</span>";
    var save = hasDiscount && !gift
      ? '<div class="ccc-item-save">(You Save ' +
        money(item.original_line_price - item.final_line_price) +
        ")</div>"
      : "";
    var titleAttr = esc(item.product_title);
    var qty = gift
      ? ""
      : '<div class="ccc-qty" role="group" aria-label="Quantity for ' + titleAttr + '" data-line="' +
        line +
        '"><button type="button" data-d="-1" aria-label="Decrease quantity of ' + titleAttr + '"' +
        (item.quantity <= 1 ? "" : "") +
        ">−</button><span aria-live=\"polite\">" +
        item.quantity +
        '</span><button type="button" data-d="1" aria-label="Increase quantity of ' + titleAttr + '">+</button></div>';
    return (
      '<div class="ccc-item" data-line="' + line + '">' +
      '<img class="ccc-item-img" src="' +
      esc(item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, "_200x$1$2") : "") +
      '" alt="" loading="lazy">' +
      "<div>" +
      '<a class="ccc-item-title" href="' + esc(item.url) + '">' +
      esc(item.product_title) +
      "</a>" +
      (gift
        ? '<span class="ccc-gift-badge">' + esc(cfg.freeGift.badgeText) + "</span>"
        : "") +
      (discounts ? '<div class="ccc-item-discount">' + discounts + "</div>" : "") +
      '<div class="ccc-item-bottom">' +
      qty +
      '<div class="ccc-item-price">' + price + save + "</div>" +
      "</div></div>" +
      '<button class="ccc-remove" type="button" aria-label="Remove ' + esc(item.product_title) + ' from cart" data-line="' +
      line +
      '">' + SVG_TRASH + "</button></div>"
    );
  }

  function render() {
    if (!cart) return;
    var body = drawer.querySelector(".ccc-body");
    var footer = drawer.querySelector(".ccc-footer");
    if (cart.item_count === 0) {
      body.innerHTML =
        rewardBarHtml() +
        '<div class="ccc-empty">' +
        esc(cfg.emptyMessage) +
        "</div>" +
        '<div class="ccc-upsell"></div>';
      footer.innerHTML = "";
      loadUpsells(null);
      return;
    }
    var items = cart.items
      .map(function (item, i) {
        return itemHtml(item, i + 1);
      })
      .join("");
    body.innerHTML =
      rewardBarHtml() +
      '<div class="ccc-items">' +
      items +
      "</div>" +
      '<div class="ccc-upsell"></div>';
    var totalSave = 0;
    cart.items.forEach(function (item) {
      if (!isGift(item))
        totalSave += item.original_line_price - item.final_line_price;
    });
    footer.innerHTML =
      '<div class="ccc-subtotal"><span>Subtotal (' +
      cart.item_count +
      (cart.item_count === 1 ? " item" : " items") +
      ')</span><span class="ccc-subtotal-amount">' +
      money(cart.items_subtotal_price, "down") +
      "</span></div>" +
      (totalSave > 0
        ? '<div class="ccc-yousave">' + SVG_TAG + " You Save " + money(totalSave) + "</div>"
        : "") +
      '<button class="ccc-checkout" type="button">' + SVG_CART + " " +
      esc(cfg.checkoutLabel) +
      "</button>";
    footer
      .querySelector(".ccc-checkout")
      .addEventListener("click", function () {
        window.location.href = "/checkout";
      });
    announce(
      "Cart updated: " +
        cart.item_count +
        (cart.item_count === 1 ? " item, " : " items, ") +
        "subtotal " +
        money(cart.items_subtotal_price, "down")
    );
    body.querySelectorAll(".ccc-qty button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var line = Number(btn.parentElement.getAttribute("data-line"));
        var d = Number(btn.getAttribute("data-d"));
        var item = cart.items[line - 1];
        if (item) setQty(item.key, Math.max(0, item.quantity + d));
      });
    });
    body.querySelectorAll(".ccc-remove").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var item = cart.items[Number(btn.getAttribute("data-line")) - 1];
        if (item) setQty(item.key, 0);
      });
    });
    var firstReal = null;
    cart.items.forEach(function (item) {
      if (!firstReal && !isGift(item)) firstReal = item;
    });
    loadUpsells(firstReal);
  }

  function loadUpsells(anchorItem) {
    if (!cfg.upsell) return;
    var placement = upsellPlacement();
    if (placement === "hidden") {
      if (sidePanel) sidePanel.classList.remove("cc-open");
      var inlineSlot = drawer.querySelector(".ccc-upsell");
      if (inlineSlot) inlineSlot.innerHTML = "";
      return;
    }
    var sidePanelMode = placement === "side-panel" && !!sidePanel;
    var slot = sidePanelMode
      ? sidePanel.querySelector(".ccc-upsell")
      : drawer.querySelector(".ccc-upsell");
    if (!slot) return;
    // Reward-gap filler: how many cents to the next reward tier?
    var gapCents = 0;
    if (cfg.rewardBar && cfg.rewardBar.tiers && cart) {
      var sub = cart.items_subtotal_price;
      for (var ti = 0; ti < cfg.rewardBar.tiers.length; ti++) {
        var th = cfg.rewardBar.tiers[ti].threshold * 100;
        if (sub < th) {
          gapCents = Math.round(th - sub);
          break;
        }
      }
    }
    var strategy = cfg.upsell.strategy || "smart";
    // Bucket the gap to $5 so tiny subtotal changes reuse the cached recs
    // instead of re-fetching on every optimistic re-render.
    var gapBucket = Math.round(gapCents / 500);
    var cacheKey =
      cfg.upsell.widgetKey +
      "|" + (anchorItem ? anchorItem.product_id : "") +
      "|" + (strategy === "recs" ? 0 : gapBucket) +
      "|" + placement;
    if (upsellCache && upsellCache.key === cacheKey) {
      renderUpsellData(upsellCache.data, slot, sidePanelMode);
      return;
    }
    var url =
      CC_HOST +
      "/storefront/recs?force=1&widget=" +
      encodeURIComponent(cfg.upsell.widgetKey) +
      (anchorItem
        ? "&product=" +
          encodeURIComponent("gid://shopify/Product/" + anchorItem.product_id)
        : "") +
      (gapCents > 0 && strategy !== "recs"
        ? "&gap=" + gapCents + "&strategy=" + strategy
        : "");
    fetch(url)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        upsellCache = { key: cacheKey, data: data };
        renderUpsellData(data, slot, sidePanelMode);
      })
      .catch(function () {});
  }

  var upsellCache = null;
  function renderUpsellData(data, slot, sidePanelMode) {
    (function (data) {
        if (!data || !data.products || data.products.length === 0) return;
        var ws = data.style || {};
        function elOn(v, dflt) {
          return v === undefined || v === null ? dflt : !!v;
        }
        var showImg = elOn(ws.showImage, true);
        var showTitle = elOn(ws.showTitle, true);
        var showPrice = elOn(ws.showPrice, true);
        var inCart = {};
        (cart ? cart.items : []).forEach(function (item) {
          inCart[String(item.product_id)] = true;
        });
        var tiles = data.products
          .filter(function (p) {
            var num = String(p.gid || "").split("/").pop();
            return !inCart[num];
          })
          .slice(0, 6)
          .map(function (p) {
            return (
              '<div class="ccc-upsell-tile">' +
              // Image is decorative when the visible title link names the
              // product; when the title is hidden the image carries the name.
              (showImg
                ? '<img src="' + esc(p.image || "") + '" alt="' +
                  (showTitle ? "" : esc(p.title)) + '" loading="lazy">'
                : "") +
              (showTitle
                ? '<a href="' + esc(p.url) + '">' + esc(p.title) + "</a>"
                : '<a href="' + esc(p.url) + '" style="display:none" aria-hidden="true" tabindex="-1"></a>') +
              (showPrice
                ? '<div class="ccc-upsell-price">$' +
                  Math.ceil(Number(p.price)).toLocaleString("en-US") + "</div>"
                : "") +
              '<button class="ccc-upsell-add" type="button" aria-label="Add ' +
              esc(p.title) + ' to cart" data-vid="' +
              esc(String(p.variantId || "")) +
              '">Add to Cart</button></div>'
            );
          })
          .join("");
        if (!tiles) {
          if (sidePanelMode) sidePanel.classList.remove("cc-open");
          return;
        }
        slot.innerHTML = sidePanelMode
          ? '<div class="ccc-upsell-row" style="display:block">' + tiles + "</div>"
          : "<h3>" + esc(cfg.upsell.heading) + '</h3><div class="ccc-upsell-row">' +
            tiles +
            "</div>";
        if (sidePanelMode && drawer.classList.contains("cc-open"))
          sidePanel.classList.add("cc-open");
        var priceByVid = {};
        data.products.forEach(function (p) {
          if (p.variantId)
            priceByVid[String(p.variantId)] = Math.round(Number(p.price) * 100);
        });
        slot.querySelectorAll(".ccc-upsell-add").forEach(function (btn) {
          btn.addEventListener("click", function () {
            var vid = Number(btn.getAttribute("data-vid"));
            if (!vid) return;
            btn.disabled = true;
            btn.textContent = "Added ✓";
            announce("Item added to cart");
            beacon(cfg.upsell.widgetKey, "add_to_cart", priceByVid[String(vid)]);
            // Attribution tag runs in parallel with the add — one round trip
            // instead of three before the drawer updates.
            tagAttribution(vid, cfg.upsell.widgetKey);
            fetch("/cart/add.js", {
              method: "POST",
              credentials: "same-origin",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: vid, quantity: 1 }),
            })
              .then(function () {
                return refresh();
              })
              .catch(function () {
                btn.disabled = false;
                btn.textContent = "Add to Cart";
              });
          });
        });
    })(data);
  }

  // ---- triggers -----------------------------------------------------------
  function interceptCartLinks() {
    document.addEventListener(
      "click",
      function (e) {
        var a = e.target && e.target.closest && e.target.closest("a[href]");
        if (!a) return;
        var href = a.getAttribute("href") || "";
        if (href === "/cart" || href === "/cart/" || href.indexOf("/cart?") === 0) {
          e.preventDefault();
          e.stopPropagation();
          open();
        }
      },
      true
    );
  }

  function interceptAddToCart() {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var p = origFetch.apply(this, arguments);
      if (url.indexOf("/cart/add") !== -1) {
        p.then(function (r) {
          if (r.ok && !giftBusy) setTimeout(open, 150);
        }).catch(function () {});
      }
      return p;
    };
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (String(url).indexOf("/cart/add") !== -1) {
        this.addEventListener("load", function () {
          if (this.status >= 200 && this.status < 300 && !giftBusy)
            setTimeout(open, 150);
        });
      }
      return origOpen.apply(this, arguments);
    };
  }

  function init() {
    fetch(CC_HOST + "/storefront/cart-config")
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        if (!c || !c.enabled) return;
        cfg = c;
        buildShell();
        interceptCartLinks();
        document.addEventListener("cc:open-cart", function () {
          open();
        });
        interceptAddToCart();
        // Keep the free-gift rule honest even if the drawer is never opened.
        fetchCart().then(function (data) {
          cart = data;
          maybeToggleGift();
        });
      })
      .catch(function () {});
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();
})();
